import React from "react";
import { Modal } from "@redriver/cinnamon";
import { Grid } from "semantic-ui-react";

const MemoryModal = ({ data, ...props }) => {
  return (
    <Modal.Information header="Memory info" size="large" {...props}>
      <div className="modalScrollContent">
        {data && (
          <Grid className="tight">
            {data.Types.map((t, i) => (
              <React.Fragment key={"c" + i}>
                <Grid.Column width={11} key={"c1" + i} className="stackPreview">
                  {t.TypeName}
                </Grid.Column>
                <Grid.Column width={2} key={"c2" + i}>
                  {Number(t.Count).toLocaleString() + " objects"}
                </Grid.Column>
                <Grid.Column width={3} key={"c3" + i}>
                  {(() => {
                    let sz = t.Size;
                    let suffix = "B";
                    if (sz > 1024) {
                      sz /= 1024;
                      suffix = "KB";
                    }
                    if (sz > 1024) {
                      sz /= 1024;
                      suffix = "MB";
                    }
                    if (sz > 1024) {
                      sz /= 1024;
                      suffix = "GB";
                    }
                    return (
                      Number(Math.floor(sz * 10) / 10).toLocaleString() +
                      " " +
                      suffix
                    );
                  })()}
                </Grid.Column>
              </React.Fragment>
            ))}
          </Grid>
        )}
      </div>
    </Modal.Information>
  );
};

export default MemoryModal;
